import { CANCEL } from '@sarunas/redux-debounce';
import createAction from '../services/create-action';

export const FETCH_SEARCH_REQUEST = 'search/FETCH_REQUEST';
export const FETCH_SEARCH_SUCCESS = 'search/FETCH_SUCCESS';
export const FETCH_SEARCH_FAILURE = 'search/FETCH_FAILURE';
export const FETCH_SEARCH_DEBOUNCED = 'search/FETCH_DEBOUNCED';

export const fetchSearchRequest = createAction(FETCH_SEARCH_REQUEST);
export const fetchSearchSuccess = createAction(FETCH_SEARCH_SUCCESS);
export const fetchSearchFailure = createAction(FETCH_SEARCH_FAILURE);

export default function fetchSearch(query) {
  return (dispatch, getState, { request }) => {
    dispatch(fetchSearchRequest());

    const promise = request(`/_api/search?q=${query}`);

    return promise
      .then(results => dispatch(fetchSearchSuccess(results)))
      .catch(() => dispatch(fetchSearchFailure()))
      .then(() => promise);
  };
}

export function fetchSearchDebounced(query, debounce = 300) {
  const action = fetchSearch(query);
  action.type = FETCH_SEARCH_DEBOUNCED;
  action.meta = { debounce };
  return action;
}

export function fetchSearchWithCancel(query, debounce = 300, minQueryLength = 2) {
  if (query.length >= minQueryLength) {
    return fetchSearchDebounced(query, debounce);
  }
  return {
    type: CANCEL,
    payload: {
      type: FETCH_SEARCH_DEBOUNCED,
    },
  };
}



// WEBPACK FOOTER //
// ./app/actions/fetch-search.js